module.exports = __webpack_public_path__ + "static/heroslide-7-db410a493961a42dd93c0ab08705e0f7.jpeg";